import React from "react";
import {Button} from "retro-react";
import "./Sidebar.css"; // Import CSS for sidebar styling
import { useNavigate } from "react-router-dom";
import star from "../../assets/star.gif" 
import mailbox from "../../assets/mailbox.gif"
import mic from "../../assets/mic.gif"
import rover from "../../assets/rover.gif"
import gallery from "../../assets/gallery.gif"
import nick from "../../assets/nick-glow.png"




const Sidebar = () => {
  const navigate = useNavigate();
  return (
        <div className="sidebar">
          <div className="button-group">
            <Button size="large" onClick={ () => navigate("/")}>
              <img src={star} alt="Star" className="star-icon" />
              Home
            </Button>
            <Button size="large" onClick={() => navigate("about")}> 
            <img src={rover} alt="Star" className="rover-icon" />
              About   
            </Button>
            <Button size="large" onClick={() => navigate("contact")}>
            <img src={mailbox} alt="Star" className="mail-icon" />
              Contact   
            </Button>
            <Button size="large" onClick={() => navigate("gallery")}> 
            <img src={gallery} alt="Star" className="gallery-icon" />
              Gallery
            </Button>
          </div>
          <div className="photo-group">
              <Button size="large">
              <img src={nick} alt="Star" className="nick-icon" />
            </Button>
            </div>
        </div>
    );
  }

export default Sidebar;
